




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AppButtonExportAddTreatmentRequest extends Vue {
  onAddTreatmentRequest() {
    this.$router.push({ name: "add-treatment-request" });
  }

  onExport() {
    this.$store.commit("EXPORT");
  }
}
